import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { ReactComponent as arrowright } from "../../../assets/icons/arrowright.svg";

const includes = ["標準ポータル構築", "主要Webパーツ配置", "初期カスタマイズ"];
 
const Pricing = () => {
  return (
    <Box sx={{ backgroundColor: "#D4D4D4", py: { xs: 6, md: 8 } }}>
      <Container maxWidth={false} sx={{ width: "92%", mx: "auto" }}>
        <Typography
          sx={{
            color: "#FF6000",
            fontWeight: 700,
            fontSize: "13px",
            letterSpacing: "1px",
            mb: 1,
          }}
        >
          PRICE
        </Typography>
 
        <Typography
          sx={{ fontWeight: 700, fontSize: { xs: "26px", md: "50px" }, mb: 1.5 }}
        >
          概算価格
        </Typography>
 
        <Typography
          sx={{
            fontSize: "20px",
            color: "rgba(0,0,0,0.65)",
            mb: { xs: 4, md: 5 },
            maxWidth: "760px",
          }}
        >
          シンプルで分かりやすい価格（追加サーバー費用・外部SaaS費用 不要）
        </Typography>
 
        <Box
          sx={{
            background: '#fff',
            borderRadius: "16px",
            border: "1px solid rgba(0,0,0,0.08)",
            p: { xs: 3, md: 5 },
            textAlign: "center",
          }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: "20px", mb: 2 }}>
            基本パッケージ
          </Typography>
 
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "center",
              gap: 1,
              mb: 3,
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: { xs: "48px", md: "96px" },
                color: "#FF6000",
                lineHeight: 1,
              }}
            >
              100
            </Typography>
            <Typography sx={{ fontWeight: 700, fontSize: { xs: "22px", md: "28px" } }}>
              万円(税別)〜
            </Typography>
          </Box>
 
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: 2,
              mb: 3,
            }}
          >
            {includes.map((item) => (
              <Box
                key={item}
                sx={{
                  border: "1px solid rgba(0,0,0,0.15)",
                  borderRadius: "8px",
                  px: 2.5,
                  py: 1,
                  minWidth: 250,
                }}
              >
                <Typography sx={{ fontSize: "20px", fontWeight: 700 }}>
                  ✓ {item}
                </Typography>
              </Box>
            ))}
          </Box>
 
          <Typography
            sx={{ fontSize: "16px", color: "rgba(0,0,0,0.55)" }}
          >
            ※大規模な外部システム連携や高度なワークフロー構築は、要件に応じて個別にお見積もりいたします。
          </Typography>
        </Box>
 
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <Button
            variant="contained"
            endIcon={<Box component={arrowright} sx={{ width: 15, height: 15, marginLeft: '10px', "& path": { fill: "#fff" },}} />}
            sx={{
              backgroundColor: "#FF6000",
              color: "#fff",
              borderRadius: "7px",
              textTransform: "none",
              fontWeight: 700,
              fontSize: "15px",
              boxShadow: 'initial',
              px: 4,
              py: 1.5,
              whiteSpace: "nowrap",
              "&:hover": { backgroundColor: "#e55500" },
            }}
          >
            自社に合う構成を無料相談で確認する
          </Button>
        </Box>
      </Container>
    </Box>
  );
};
 
export default Pricing;